import { InvoicesDashboard } from "../../Dashboard/dashboard.types";

export interface InvoiceNotesCardTypes {
    invoiceDetails?: InvoicesDashboard;
}

export enum ActivityType {
    Adjustment = 'Adjustment',
    Chargeback = 'Chargeback',
    Denied = 'Denied',
    Note = 'Note',
    Payment = 'Payment',
    Funded = 'Funded',
    Rejected = 'Rejected',
    ShortPay = 'Short Pay',
    Submitted = 'Submitted',
    Invoice = 'Invoice',
}

export enum TransactionType {
    Adjustment = 'Adjustment',
    Chargeback = 'Chargeback',
    ShortPay = 'Short Pay',
    OverPay = 'Overpay',
    Payment = 'Payment',
    Purchase = 'Purchase',
    Submitted = 'Submitted',
}

export enum ActivityStatus {
    Paid = 'Paid',
    Funded = 'Funded',
    Submitted = 'Submitted',
    Adjustment = 'Adjustment',
    Recoursed = 'Recoursed',
}
